// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__25kVZ","checkboxCol":"Table_checkboxCol__2WdlK","emailCol":"Table_emailCol__2NAgn","actionCol":"Table_actionCol__4_svB"};